import React from 'react'

import TextArea from 'components/Form/TextArea/TextArea'

import styles from './FormTextArea.module.scss'

const FormTextArea = ({ ...props }) => <TextArea {...props} labelClassName={styles.label} />

export default FormTextArea
